
import global from 'Core/global';
import throttle from 'Utils/throttle';

export default function size () {

	let windowWidth = window.innerWidth;

	setGlobalState();

	throttle('resize', () => {

		if (windowWidth !== window.innerWidth) {

			windowWidth = window.innerWidth;

			setGlobalState();

		}

	}, 0);

	function setGlobalState () {

		const config 	= global.config.size;
		let size 		= 's';
		let nav 		= 'mobile';

		if (windowWidth >= config.m && windowWidth < config.l) {

			size = 'm';

		} else if (windowWidth >= config.l && windowWidth < config.xl) {

			size = 'l';

		} else if (windowWidth >= config.xl) {

			size = 'xl';

		}

		if (windowWidth >= config[config.nav]) {

			nav = 'desktop';

		}

		global.state.size 	= size;
		global.state.nav 	= nav;

	}

}
